/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Spain_Faq_A6Inputs */

const es_marketplace_seo_spain_faq_a6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para navegar un velero por tu cuenta necesitas titulación adecuada. Si no la tienes, reserva un velero con patrón o prueba primero un barco sin licencia.`)
};

const gl_marketplace_seo_spain_faq_a6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para navegar un veleiro por ti mesmo necesitas titulación axeitada. Se non a tes, reserva un veleiro con patrón ou proba primeiro un barco sen licenza.`)
};

const en_marketplace_seo_spain_faq_a6 = /** @type {(inputs: Marketplace_Seo_Spain_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To sail a yacht yourself you need the right licence. If you do not have one, book a sailboat with skipper or try a licence-free motorboat first.`)
};

/**
* | output |
* | --- |
* | "To sail a yacht yourself you need the right licence. If you do not have one, book a sailboat with skipper or try a licence-free motorboat first." |
*
* @param {Marketplace_Seo_Spain_Faq_A6Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_spain_faq_a6 = /** @type {((inputs?: Marketplace_Seo_Spain_Faq_A6Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Spain_Faq_A6Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_spain_faq_a6(inputs)
	if (locale === "en") return en_marketplace_seo_spain_faq_a6(inputs)
	return es_marketplace_seo_spain_faq_a6(inputs)
});